export default "/images/69e66606559b88a0a1966ae40280895d.avif";